import {Component, OnInit} from "@angular/core";
import {DocumentService} from "../../services/document.service";
import {LockService} from "../../services/lock.service";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  selector: "nv-lock-indicator",
  templateUrl: "./nv-lock-indicator.component.html"
})


export class NvLockIndicatorComponent implements OnInit {
  public document: IDocument;

  private intervalId: number;
  private editable: boolean;

  progress: any = {
    width: 100,
    value: ""
  };


  constructor(private busService: BusService,
              private lockService: LockService) {
  }


  ngOnInit(): void {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateState(e));
  }


  private updateState(e: INewDocumentEvent) {
    this.clear();

    if (!(this.document = e.document)) {
      return;
    }

    if (this.editable = !e.readonly) {
      this.intervalId = setInterval(this.updateLockTime.bind(this), 200);
    }
  }


  private updateLockTime(): void {
    let ratio: number = this.lockService.getTimeleftRatio(this.document._id);
    this.progress.width = Math.floor(ratio * 100);
    this.progress.value = ratio.toFixed(3);
  }

  private clear(): void {
    clearInterval(this.intervalId);

    this.document = null;
    this.progress.width = 0;
    this.progress.value = "0";
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-lock-indicator/nv-lock-indicator.component.ts